import { jsx as _jsx } from "react/jsx-runtime";
export const ModalFooter = ({ children }) => {
    return (_jsx("div", { className: "mt-5 flex flex-col gap-y-2 sm:mt-4 sm:flex-row-reverse sm:gap-x-2", children: children }));
};
export default ModalFooter;
